import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SidebarData, getSidebarData } from "./SidbarData";
import "../styles/Navbar.css";
import "../styles/Price.scss";
import "../styles/Price.css";
import { useDispatch, useSelector } from "react-redux";
import { getTour } from "../store/actions/handleTour";
import { styled, useTheme } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
  background: "#071358",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
  background: "#071358",
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== "open" })(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

function Navbar() {
  const { start } = useSelector((state) => state.tourReducer);
  const [check, setCheck] = useState(start);
  const [sidebarItems, setSidebarItems] = useState([]);

  const dispatch = useDispatch();

  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    dispatch(getTour());
    setCheck(start);

    // Ogni volta che il componente viene montato o viene aggiornato lo stato dell'utente,
    // leggiamo i dati per la sidebar dall'email aggiornata nel localStorage
    setSidebarItems(getSidebarData());
  }, [dispatch, start]);

  // Aggiorniamo la sidebar quando cambia lo storage o quando l'utente si autentica
  useEffect(() => {
    // Funzione che gestisce i cambiamenti nel localStorage
    const handleStorageChange = () => {
      setSidebarItems(getSidebarData());
    };

    // Funzione che gestisce il cambiamento dello stato di autenticazione dell'utente
    const handleAuthChange = () => {
      setSidebarItems(getSidebarData());
    };

    // Aggiungiamo i listener per il cambiamento dello storage e per l'evento personalizzato
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("userAuthStateChanged", handleAuthChange);

    // Cleanup: rimuoviamo i listener quando il componente viene smontato
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      window.removeEventListener("userAuthStateChanged", handleAuthChange);
    };
  }, []);

  return (
    <Drawer variant="permanent" open={open}>
      <DrawerHeader>
        {open ? (
          <IconButton onClick={handleDrawerClose} sx={{ color: "#ffffff" }}>
            {theme.direction === "rtl" ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        ) : (
          <IconButton
            color="red"
            // aria-label="open drawer"
            onClick={handleDrawerOpen}
            sx={{
              marginRight: "3.5px",
              color: "#ffffff",
            }}
          >
            <MenuIcon />
          </IconButton>
        )}
      </DrawerHeader>
      <Divider />
      <Avatar
        src="https://i.ibb.co/bQbnG8k/logo-es-br-40-512-512.png"
        sx={{
          width: 50,
          height: 50,
          marginLeft: "7px",
          marginTop: "10px",
          marginBottom: "10px",
          border: "1px solid #ffffff",
        }}
      />

      <Divider />
      <List>
        {sidebarItems.map((text, index) => (
          <Link to={text.path} style={{ textDecoration: "none" }} className="menu-bars" key={index}>
            <ListItem key={index} disablePadding sx={{ display: "block" }}>
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                    color: "#ffffff",
                  }}
                >
                  {text.icon}
                </ListItemIcon>
                <ListItemText
                  primary={text.title}
                  sx={{
                    opacity: open ? 1 : 0,
                    color: "#ffffff",
                    textDecoration: "none !important",
                  }}
                />
              </ListItemButton>
            </ListItem>
          </Link>
        ))}
      </List>
      <div style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
        <Divider />
        <Link to="/logout" className="menu-bars">
          <ListItem key={"1231241321"} disablePadding sx={{ display: "block" }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? "initial" : "center",
                px: 2.5,
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : "auto",
                  justifyContent: "center",
                  color: "#ffffff",
                }}
              >
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary="Logout" sx={{ opacity: open ? 1 : 0, color: "#ffffff" }} />
            </ListItemButton>
          </ListItem>
        </Link>
      </div>
    </Drawer>
  );
}

export default Navbar;
